import {
  always,
  ifElse,
  reduce,
  has,
  assoc,
  set,
  lensProp,
  identity,
  pipe,
  all,
  dissoc,
  isEmpty,
  isNil,
  hasPath,
  prop,
} from 'ramda'

const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

export const getNewTimes = (shouldSelect, day, availableWeekdayTimes) => {
  const times = availableWeekdayTimes || {}
  if (shouldSelect) {
    if (!has(day)(times)) return assoc(day, [], times)
    else return set(lensProp(day), [], times)
  } else return pipe(dissoc(day), ifElse(isEmpty, always(null), identity))(times)
}

export const defaultToObject = ifElse(isNil, always({}), identity)

export const allDaysAreSelected = pipe(defaultToObject, x =>
  reduce((a, n) => a && has(n, x), true)(daysOfWeek),
)

export const getTimes = availableWeekdayTimes => day =>
  ifElse(
    hasPath([day, 0, 'StartTime']),
    prop(day),
    always([{ StartTime: null, EndTime: null }]), // need to return at least one element in array to render time component
  )(availableWeekdayTimes)
